<app-reg-base-step-wizard [navigationSteps]="navigationSteps" [parentForm]="parentForm" (selectStep)="setStep($event)" [personal]="false">
    <div>
        <app-personal [parentForm]="parentForm" [showForm]="selectedStep === 1" [loading]="loadingData" [states]="states" [countries]="countries"></app-personal>
        <app-business [parentForm]="parentForm" [showForm]="selectedStep === 2" [loading]="loadingData" [states]="states" [countries]="countries" [businessCodes]="businessCodes"></app-business>
        <app-password [parentForm]="parentForm" [showForm]="selectedStep === 3"></app-password>
        <app-success [showForm]="selectedStep === 99"></app-success>
        <app-failure [showForm]="selectedStep === 100"></app-failure>
    </div>
</app-reg-base-step-wizard>